import { CoreDisplayableRef, PageResult} from "./CoreModels"
import { CorePasswordAdminAccountRole } from "./CorePasswordAdminModels"
import { PageRequest } from "./Requests"
import {CorePasswordChangeRole } from "./CoreInstanceSettings"


export interface PasswordChangeSearchPageRequest extends PageRequest {
    classGroupId?: string,
    schoolUnitId?: string,
    search?: string,
    role?: CorePasswordAdminAccountRole
}

export interface CorePasswordChangeRequest {
    password?: string,
    passwordProfileId?: string,
    forcePasswordChangeAtNextLogin: boolean,
    appTokenId?: string,
    trackingIds: string[]
}

export interface CorePasswordChangeResult {
    tracking?: {
        id?: string,
        flowSyncId?: string,
        sourceSystemId?: string,
        flowSyncObject?: {
            displayName?: string
        }
    },
    newPassword?: string,
    success?: boolean,
    errorMessage?: string
}

export interface CorePasswordChangeUser {
    id: string
    userId: string
    userDisplayName: string
    username: string
    schoolUnits: CoreDisplayableRef[]
    classGroup: CoreDisplayableRef[]
    role: CorePasswordAdminAccountRole
    environment: string
}

export const PasswordChangeSettingRoleOptions: CorePasswordChangeRole[] = [
    CorePasswordChangeRole.STUDENT,
    CorePasswordChangeRole.STAFF
]

export interface CorePasswordChangeUsersResponse {
    accessRole: CorePasswordChangeRole
    users: PageResult<CorePasswordChangeUser>
}